export const ANALYTICS_MODE = {
  CLIENT: "client",
  SERVER_ONLY: "serverOnly",
};

export const CLIENT_TABS = ["Sessions", "API Requests", "Pages"];

export const SERVER_ONLY_TABS = ["Sessions", "API Requests"];
